<template>
  <div class="w-full">
    <div class="flex justify-between align-center" style="margin-top: -1.5rem">
      <SmartTitle
        weight="medium"
        heading="1"
        style="font-size: 2em"
      >
        Acompanhar Meta
      </SmartTitle>
      <SmartButton
        @click="showInfoSendModal"
        v-if="goalStartedGetter.allAproved" class="mr-4" quaternary>
        Distribuir por CV
      </SmartButton>
    </div>
    <section class="secao">
      <template v-if="isLoading">
        <SmartCardViewSkeleton
          v-for="i in 6"
          :key="`${i}-skeleton`"
        />
      </template>
      <template v-else>
        <SmartCardView
          v-for="regional in goalStartedGetter['views']"
          :key="regional.view_id"
          :stateSigles="regional.uf"
          :status="regional.status"
          :viewName="regional.view_name"
          @publishGoal="publishGoal(lastGoalStartedGetter.id,regional.view_id)"
        >
          <SmartButton
            @click="(sendReminder.status = true) && (sendReminder.view_id = regional.view_id)"
            v-if="regional.status_slug === 'calibracao_regional'"
            class="mt-4 mr-4" quaternary style="z-index: 9">
            Enviar Lembrete
          </SmartButton>
          <SmartButton
            @click="resolve"
            v-if="regional.status_slug !== 'meta_aprovada' && regional.status_slug === 'calibracao_hq'"
            class="mt-4 mr-4" quaternary style="z-index: 9">
            Resolver
          </SmartButton>
          <SmartButton
            @click="publishGoal(lastGoalStartedGetter.id, regional.view_id)"
            v-if="regional.status_slug !== 'meta_aprovada' && regional.status_slug === 'meta_distribuida_cv'"
            class="mt-4 mr-4" quaternary style="z-index: 9"
            :loading="isLoading">
            Publicar Meta
          </SmartButton>
        </SmartCardView>
      </template>
    </section>
    <ModalSendReminder
      v-if="sendReminder.status"
    >
      <h3 class="title-modal">Lembrete de Andamento</h3>
      <label class="label-modal">Descrição do Lembrete
        <br/>
        <input type="text" v-model="sendReminder.message" class="input-modal" placeholder="Fale sobre a necessidade do andamento para o processo"/>
      </label>
      <div class="area-buttons">
        <SmartButton
          @click="sendReminder.status = false"
          class="mr-4 btn-cancel">
          Cancelar
        </SmartButton>
        <SmartButton
          @click="sendReminde"
          class="mr-4 btn-send" color="success">
          Enviar
        </SmartButton>
      </div>
    </ModalSendReminder>
    <SmartModal
      v-if="submitModal"
      v-bind="submitModal"
      @return="sendCVs"
      @close="submitModal = null"
    >
      {{ submitModal.text }}
    </SmartModal>
    <SmartModal
      v-if="modal"
      v-bind="modal"
      @close="modal = null">
      {{ modal.text }}
    </SmartModal>


    <v-snackbar
      v-model="snackbar"
      style="bottom: 3rem;"
    >
      Meta Publicada com Sucesso!
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    SmartCardView: () => import('./components/SmartCardView'),
    SmartCardViewSkeleton: () => import('./components/SmartCardViewSkeleton'),
    ModalSendReminder: () => import('./components/ModalSendReminder')
  },
  data() {
    return {
      submitModal: null,
      modal: null,
      status: '',
      sendReminder: { status: false, message: '', view_id: null },
      isLoading: false,
      snackbar: false
    };
  },
  computed: {
    ...mapGetters({
      goalStartedGetter: 'baseline/goalStartedGetter',
      lastGoalStartedGetter: 'baseline/lastGoalStartedGetter'
    })
  },
  methods: {
    ...mapActions({
      getGoalStarted: 'baseline/getGoalStarted',
      splytByCV: 'baseline/splytByCV',
      sendPublishGoal: 'baseline/publishGoal',
      sendReminderMessage: 'baseline/sendRemide'
    }),
    async publishGoal(goal, view) {
      await this.sendPublishGoal({ goal_id: goal, view_id: view }).then(() => { this.snackbar = true; });
      this.loading();
    },
    distribuirPorCVS() {
      // ação que irá de fatos distribuir as metas entre os CVS
      // Popular assim que endPoint estiver disponivel
    },
    showSuccessModal() {
      this.modal = {
        type: 'success',
        title: 'Ok, tudo certo!',
        icon: 'accepted',
        buttonText: 'Ok',
        routerRedirect: 'PainelMetas',
        text:
          'As metas foram distribuidas por CVS com sucesso!'
      };
    },
    showErrorModal(message) {
      this.modal = {
        type: 'error',
        title: 'Erro desconhecido',
        icon: 'alert',
        buttonText: 'Ok',
        text: message
      };
    },
    showNotificationSuccessModal() {
      this.modal = {
        type: 'success',
        title: 'Lembrete Enviado!',
        icon: 'accepted',
        buttonText: 'Ok',
        text:
          'Seu lembrete foi enviado com sucesso!'
      };
    },
    showInfoSendModal() {
      this.submitModal = {
        type: 'warning',
        title: 'Distribuir entre CV',
        icon: 'alert',
        buttonText: 'Não, cancelar',
        secondButton: 'Sim, Enviar',
        text: 'Deseja distribuir metas entre Cvs'
      };
    },
    showLoadingModal() {
      this.modal = {
        type: 'default',
        title: 'Enviando...',
        icon: 'union',
        text: 'Estamos subindo as informações, aguarde um instante...'
      };
    },
    showNotificationLoadingModal() {
      this.modal = {
        type: 'default',
        title: 'Enviando Lembretes...',
        icon: 'union',
        text: 'Estamos enviando os lembretes...'
      };
    },
    showNotificationErrorModal() {
      this.modal = {
        type: 'error',
        title: 'Lembrete Não Enviado',
        icon: 'alert',
        buttonText: 'Ok',
        text: 'Não há responsáveis nesse regional'
      };
    },
    async sendCVs() {
      this.submitModal = null;
      this.showLoadingModal();
      this.submiting = true;
      this.splytByCV()
        .then(() => {
          this.submiting = false;
          this.showSuccessModal();
        })
        .catch(({ data }) => {
          this.submiting = false;
          this.showErrorModal(data.message ? data.message : 'Ocorreu um erro inesperado. Tente novamente ou contate a equipe técnica se o problema persistir.');
          return false;
        });
    },

    async sendReminde() {
      this.sendReminder.status = false;
      this.showNotificationLoadingModal();
      this.submiting = true;

      await this.sendReminderMessage(this.sendReminder).then(() => {
        this.submiting = false;
        this.showNotificationSuccessModal();
      }).catch((erro) => {
        this.submiting = false;
        this.showNotificationErrorModal(erro);
        return false;
      });

      this.sendReminder.message = '';
    },

    resolve() {
      this.$router.push('/metas/validacao-de-metas/validacao-hq/');
    },

    async loading() {
      this.isLoading = true;
      await this.getGoalStarted(this.$route.params.id);
      this.isLoading = false;
    }

  },
  async mounted() {
    this.loading();
  }
};
</script>

<style lang="scss" scoped>

.space {
  margin-top: 45px;
}

.secao {
  display: grid;
  grid-template-columns: repeat(auto-fill, 480px);
  grid-gap: 24px;
}

#regional {
  font-size: 48px;
  border-radius: 8px;
  border: 2px solid rgba(0, 0, 0, 0.1);
}

</style>
